import { useTranslation } from 'react-i18next';
import { useModal } from '../contexts';
import Modal from './Modal';

interface Props {
  onClear: () => void;
}

function WorkflowModalCustomFormattingWarning(props: Props) {
  const { closeModal } = useModal();
  const { t } = useTranslation();

  function handleDisable() {
    props.onClear();
    closeModal();
  }

  function handleCancel() {
    closeModal();
  }

  return (
    <Modal
      title={t("Warning!")}
      subtitle={t("Disabling custom formatting will clear HTML content.")}
      primaryButtonProps={{ onClick: handleCancel, text: t("Cancel"), className: "btn-white" }}
      secondaryButtonProps={{ onClick: handleDisable, text: t("Disable and remove content"), className: "btn-red" }}
      size='sm'
    />
  );
}

export default WorkflowModalCustomFormattingWarning;
